import repository from '@/repositories/repository'
import urlUtil from '@/utils/url'

export default baseUrl => {

    baseUrl = `${baseUrl}/plantao`

    const headers = { responseType: "arraybuffer" }

    return {
        exportPlantao(queryParms) {

            return repository.get(`${baseUrl}/export-plantao?${urlUtil.serialize(queryParms)}`, headers)
        }
    }
}
